<script>
import AppPageHeader from '../../../components/main/PageHeader'
import EmptyList from '../../../components/list/EmptyList'

import * as restfulService from '../../../services/restfulService'
import * as $contratoService from '../services/contratoService'

import bus from '@utils/bus'
import helpers from '@mixins/helper'
import {mapGetters} from 'vuex'

export default {
  mixins: [helpers],
  components: {AppPageHeader, EmptyList},
  mounted () {
    this.carregarTurmas()
  },
  data () {
    return {
      turma: null,
      turmas: [],
      mostrarModalBoletim: false,
      boletimBase64: ''
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    habilitarGeracaoBoletim: function () {
      return this.turma
    }
  },
  methods: {
    carregarTurmas () {
      $contratoService.buscarTurmasAlunoEnsinoBasico()
        .then((response) => {
          this.turmas = [...this.turmas, ...response]
          bus.$emit('hide-loader')
        })
        .catch(e => {
          bus.$emit('hide-loader')
          console.log(e)
        })
    },
    gerarBoletim () {
      bus.$emit('show-loader', {message: 'Estamos gerando o seu boletim/parecer'})
      let data = {
        ref_escola: this.turma.ref_escola,
        ref_periodo: this.turma.ref_periodo,
        grupo: this.turma.grupo
      }
      restfulService.post('boletim', 'pdf', null, data)
        .then((response) => {
          if (response.base64) {
            this.boletimBase64 = 'data:application/pdf;base64,' + response.base64
          }
          this.mostrarModalBoletim = true
          bus.$emit('hide-loader')
        })
        .catch(e => {
          bus.$emit('hide-loader')
          console.log(e)
        })
    }
  }
}
</script>

<template>
  <div class="page-content">
    <app-page-header/>
    <div class="box">
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select :items="turmas"
                      v-model="turma"
                      label="Curso"
                      no-data-text="Nenhum curso encontrado"
                      clearable
                      return-object
                      item-text="descricao"/>
          </v-flex>
        </v-layout>
      </v-container>
      <empty-list v-if="!habilitarGeracaoBoletim"
                  title="Selecione o Curso"
                  description="Para habilitar a geração do boletim/parecer você precisa selecionar o curso"/>
      <div class="text-xs-center" style="padding-bottom: 15px">
        <v-btn color="primary" large
               :disabled="!habilitarGeracaoBoletim"
               @click="gerarBoletim()">
          <i class="fas fa-print"></i>
          <span class="pl-1">Gerar Boletim/Parecer</span>
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="mostrarModalBoletim" width="80%">
      <v-card class="modal-pdf">
        <v-card-text>
          <iframe :src="boletimBase64"></iframe>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="mostrarModalBoletim = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// BoletinsPareceres.vue?1107baa1